import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Toote ostukorvi lisamiseks on vaja ülevalpool sektsioonis “Toote lisavalikud” teha valikud

  <span style="color:#85c1dc;">**FI:**</span>
  Jotta voit lisätä tuotteen ostoskoriin, sinun tulee tehdä valintoja yllä olevasta "Tuotteen lisävaihtoehdot" -kohdasta

  <span style="color:#85c1dc;">**RU:**</span>
  Чтобы добавить товар в корзину, необходимо сделать выбор в разделе "Дополнительный выбор товара" выше
*/
/* @__NO_SIDE_EFFECTS__ */
const m1517 = msg(
  mf`Toote ostukorvi lisamiseks on vaja ülevalpool sektsioonis “Toote lisavalikud” teha valikud`,
  mf`Jotta voit lisätä tuotteen ostoskoriin, sinun tulee tehdä valintoja yllä olevasta "Tuotteen lisävaihtoehdot" -kohdasta`,
  mf`Чтобы добавить товар в корзину, необходимо сделать выбор в разделе "Дополнительный выбор товара" выше`,
)

export { m1517 as 'w.module.submission_form.choose_options_tooltip' }